// extracted by mini-css-extract-plugin
export default {"greeting":"PlaceOrder_greeting__8VoCY","container":"PlaceOrder_container__cNN5r","link":"PlaceOrder_link__BHOOX"};